<template lang="pug">
  v-container(fluid fill-height)
    v-layout(align-center justify-center)
      v-flex()
        v-card.elevation-12
          v-toolbar(color="primary" dark flat)
            v-toolbar-title Предоставление доступа сайту {{ site }}
          v-card-text
            validation-observer(ref="observer" v-slot="{ handleSubmit }")
              v-form
                template(v-if="!isAuthenticated")
                  validation-provider(vid="username" v-slot="{ errors }" name="Логин" rules="required")
                    v-text-field(
                      v-model="username"
                      label="Логин"
                      prepend-icon="person"
                      :error-messages="errors"
                      type="text"
                    )
                  validation-provider(vid="password" v-slot="{ errors }" name="Пароль" rules="required")
                    v-text-field(
                      id="password"
                      v-model="password"
                      label="Пароль"
                      prepend-icon="lock"
                      :error-messages="errors"
                      type="password"
                      @keyup.enter="handleSubmit(signIn)"
                    )
                validation-provider(vid="location" v-slot="{ errors }" name="Разрешения" rules="required")
                  v-autocomplete(
                    v-model="scopes"
                    label="Разрешения"
                    item-value="name"
                    item-text="description"
                    :items="scopeList"
                    :error-messages="errors"
                    :search-input.sync="search"
                    multiple
                  )
                v-card-actions
                  v-btn(color="primary" @click="handleSubmit(approve)") Предоставить доступ
</template>

<script>
import Actions from '@/store/actions';
import AuthService from '@/services/authorization/auth';
import { mapGetters } from 'vuex';
import entityApi from '@/services/api/entityApi';

export default {
  name: 'Oauth2Login',
  data() {
    return {
      username: '',
      password: '',
      userId: null,
      client_id: null,
      redirect_uri: null,
      state: null,
      scopes: null,
      scopeList: null,
      search: null,
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
    ]),
    site() {
      if (!this.redirect_uri) {
        return 'No hostname';
      }
      return new URL(this.redirect_uri).host;
    },
  },
  created() {
    const {
      client_id: clientId, redirect_uri: redirectUri, state, scope,
    } = this.$route.query;
    this.client_id = clientId;
    this.redirect_uri = redirectUri;
    this.state = state;
    this.refreshScopes({ 'filter[scopeName]': scope });
  },
  watch: {
    search(val) {
      this.refreshScopes({ 'filter[scopeName]': val });
    },
  },
  methods: {
    refreshScopes(params) {
      entityApi.scope.index(params).then((response) => {
        response.onSuccess((data) => {
          this.scopeList = data.data;
        });
      });
    },
    approve() {
      if (!this.isAuthenticated) {
        this.$store.dispatch(Actions.SIGN_IN, { username: this.username, password: this.password }).then((response) => {
          response.onSuccess(() => {
            AuthService.oauth2Authorize({
              response_type: 'code',
              client_id: this.client_id,
              redirect_uri: this.redirect_uri,
              scope: this.scopes.join(' '),
              state: this.state,
            }).then((connectResponse) => {
              connectResponse.onSuccess((data) => {
                this.$toasted.success('Успешная авторизация', { duration: 4000 });
                window.location = data.redirectUrl;
              });
            });
          });
        });
      } else {
        AuthService.oauth2Authorize({
          response_type: 'code',
          client_id: this.client_id,
          redirect_uri: this.redirect_uri,
          scope: this.scopes.join(' '),
          state: this.state,
        }).then((connectResponse) => {
          connectResponse.onSuccess((data) => {
            this.$toasted.success('Успешная авторизация', { duration: 4000 });
            window.location = data.redirectUrl;
          });
        });
      }
    },
  },
};
</script>
